import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);

// Signal to @prerenderer/rollup-plugin (renderAfterDocumentEvent) that the
// route has finished its initial render so the resulting HTML can be captured.
// Fires after a microtask + paint so React + Helmet have committed.
requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    document.dispatchEvent(new Event("render-trigger"));
  });
});
